import React from 'react';
import { PurchaseLot } from '../../../../../../types/entities.js';
import { Link } from '@/npm/next.js';

interface Props {
  lot: PurchaseLot;
}

const LotBoundToLots: React.FC<Props> = ({ lot }) => {
  if (!lot.boundToLots || !lot.boundToLots.length) {
    return null;
  }

  return (
    <>
      <dt>Извещения о закупках</dt>
      <dd>
        {lot.boundToLots.map(({ lot }, i) => {
          return (
            <div key={i}>
              <Link href={`/purchases/${lot?.announce?.id}/main`}>
                {lot.announce.number}: {lot?.announce?.title}
              </Link>
              <br />
              <br />
            </div>
          );
        })}
      </dd>
    </>
  );
};

export default React.memo(LotBoundToLots);
